module.exports = __webpack_public_path__ + "static/media/bat.5df7291d.jpg";